import { collectPages } from "../../shared/api/collect-pages.js";
import { useQuery } from "@tanstack/react-query";

import { requireData } from "../../shared/api/api-error.js";
import { useApi } from "../../shared/api/api-context.js";
import { activityView } from "./models.js";

export const activityKeys = { all: ["activities"] as const };

export interface ActivityListFilters {
  readonly botId?: string;
  readonly botRunId?: string;
  readonly brokerAccountId?: string;
  readonly correlationId?: string;
  readonly fillId?: string;
  readonly from?: string;
  readonly orderId?: string;
  readonly status?: string;
  readonly symbol?: string;
  readonly to?: string;
  readonly type?: string;
}

export interface ActivitySummaryFilters {
  readonly botId?: string;
  readonly brokerAccountId?: string;
  readonly from?: string;
  readonly symbol?: string;
  readonly to?: string;
}

export function useActivities(_cursor: string, filters: ActivityListFilters) {
  const api = useApi();
  return useQuery({
    queryFn: async ({ signal }) => {
      const page = await collectPages(async (cursor) =>
        requireData(
          await api.GET("/activities", {
            params: {
              query: { limit: 100, ...(cursor === "" ? {} : { cursor }), ...filters },
            },
            signal,
          }),
        ),
      );
      return { items: page.items.map(activityView) };
    },
    queryKey: [...activityKeys.all, "list", filters],
    refetchInterval: 15_000,
  });
}

export function useActivitySummary(filters: ActivitySummaryFilters) {
  const api = useApi();
  return useQuery({
    queryFn: async ({ signal }) =>
      requireData(
        await api.GET("/activities/summary", {
          params: {
            query: {
              ...(filters.botId === undefined ? {} : { botId: filters.botId }),
              ...(filters.brokerAccountId === undefined
                ? {}
                : { brokerAccountId: filters.brokerAccountId }),
              ...(filters.from === undefined ? {} : { from: filters.from }),
              ...(filters.symbol === undefined ? {} : { symbol: filters.symbol }),
              ...(filters.to === undefined ? {} : { to: filters.to }),
            },
          },
          signal,
        }),
      ),
    queryKey: [...activityKeys.all, "summary", filters],
    refetchInterval: 15_000,
  });
}
